
<div class="padding-20 ui-g" id="c3_searchDistributionList_Modal">
  <app-campaign-3-kontable
  *ngIf="distributionList && show.table"
  id="distributionListTable"
  [columns] = "[
  { field: 'distributionListId', title: 'Id' },
  { field: 'distributionListName', title: 'campaign.description' },
  { field: 'clusterList', title: 'campaign.clusterList' }
]"

  [paginationType]="paginationType"
  [showInfoButton]="false"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="true"
  [source]="distributionList"
  (onSelected)="onDistributionListSelected($event)"
  #distributionListTable>

</app-campaign-3-kontable>
 <br />
 <br />
 <br />

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-distribution-list/campaign-3-search-distribution-list.component.html